export default {
	'technical-and-financial-offers': 'العروض الفنية والمالية',
    'the-technical-and-financial-offers': 'العرض المالي والفني؟',
    'technical-and-financial-offer': 'العرض الفني والمالي',
    'add-a-technical-and-financial-offer': 'إضافة عرض فني ومالي'
}